<template>
  <div v-if="show" class="history_action">

    <div v-if="header !== ''" class="history_action__header">
      <span>{{ header }}</span>
    </div>

    <div class="history_action__empty" v-if="Object.keys(actions).length === 0">
      {{ translate("summary.actions.empty_list") }}
    </div>

    <div
      v-else
      v-for="(action, key) in actions"
      class="action-item"
      :key="key"
    >
      <div class="action-card">

        <div class="action-card_header">
          <span class="action-card_header_name">{{action.module}}</span>
          <span class="action-card_header_ts">{{action.ts}}</span>
        </div>

        <div class="action-card_content" v-html="update_text(action.msg)"></div>
      </div>

    </div>
  </div>

  <div v-else style="height: 100%" >
    <div class="spinner">
      <scale-loader />
    </div>
  </div>

</template>

<script>

export default {
  name: 'HistoryAction',
  components: {
  },
  props: ['type', 'params'],
  data () {
    return {
      show: false,
      actions: [],
      header: ''
    }
  },
  mounted () {
    this.get_action_history()
  },
  watch:{
    type(){
      clearInterval(this.interval)
      this.get_action_history()
    },
    params(){
      clearInterval(this.interval)
      this.get_action_history()
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  deactivated(){
    clearInterval(this.interval)
  },

  methods: {
    update_text(text){
      return text.replace(/\n/g, '<br>')
    },
    get_dev_history(){
      this.$http.v1.getDeviceHistoryAction(this.params.device_id, (response) => {
        this.actions = response.data;
        this.show = true
      })
    },
    get_simdev_history(){
      this.$http.v1.getSimcardHistoryAction(this.params.simcard_id, (response) => {
        this.actions = response.data
        this.show = true
      })
    },
    get_simpro_history(){
      this.$http.simcard.getSimcardHistoryAction(this.params, (response) => {
        this.actions = response.data.data;
        this.header = response.data.title;
        this.show = true
      })
    },
    get_esimpro_history(){
      this.$http.simcard.getEsimHistoryAction(this.params, (response) => {
        this.actions = response.data.data;
        this.header = response.data.title;
        this.show = true
      })
    },
    get_action_history(){
      switch (this.type) {

        case 'device': {
          this.get_dev_history()
          this.interval = setInterval(() => {
            this.get_dev_history()
          }, this.$store.getters.getHistoryActionUpdate)
          break;
        }

        case 'simcard_devices': {
          this.get_simdev_history()
          this.interval = setInterval(() => {
            this.get_simdev_history()
          }, this.$store.getters.getHistoryActionUpdate)
          break;
        }

        case 'simcard_profile': {
          this.get_simpro_history()
          this.interval = setInterval(() => {
            this.get_simpro_history()
          }, this.$store.getters.getSimcardProfileActionsHistory)
          break;
        }

        case 'esim_profile': {
          this.get_esimpro_history()
          this.interval = setInterval(() => {
            this.get_esimpro_history()
          }, this.$store.getters.getEsimActionsHistory)
          break;
        }
      }
    }
  },
}

</script>
<style lang='scss' scoped>
  .history_action{
    display: flex;
    flex-direction: column;
    height: 100%;
    &__header{
      text-align: center;
      font-size: 18px;
      line-height: 150%;
      padding: 10px 0;
    }
    &__empty{
      padding: 10px 0;
      text-align: center;
      font-weight: 600;
      font-size: 14px;
      color: #66615b;
    }
    .action{
      &-item{
        width: 100%;
        margin: 5px 0;
        &:first-child{
          margin-top: 0;
        }
      }
      &-card{
        border-radius: 10px;
        box-shadow: 0 2px 2px #ccc5b980;
        color: #252422;
        position: relative;
        border: 1px solid #ccc;
        background-color: #f8f8f8;
        font: 300 1.3rem/150% "Roboto", Arial, sans-serif;
        &_header{
          text-transform: uppercase;
          color: #000;
          background: #f4f3ef;
          padding: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          border-radius: 10px 10px 0 0;
          overflow: hidden;
        }
        &_content {
          text-align: left;
          padding: 10px;
          background-color: #e2ecdc;
          border-radius: 0 0 10px 10px;
          overflow: hidden;
        }
      }
    }
  }
  @media (max-width:1350px){
    .history_action{
      overflow-y: auto;
    }
  }
</style>
